export default function GuardianRankChip({
  rank,
  onPress,
}: {
  rank: number
  onPress?: () => void
}) {
  const body = (
    <span className="inline-flex items-center rounded-lg border border-guardians-accent/40 bg-guardians-accent/15 px-2 py-0.5 text-xs font-extrabold text-guardians-accent">
      Ранг {rank}
    </span>
  )
  if (onPress) {
    return (
      <button type="button" onClick={onPress} className="text-left">
        {body}
      </button>
    )
  }
  return body
}
